/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UnresolvedVendorErrorCodeStatus } from './UnresolvedVendorErrorCodeStatus';
import {
    UnresolvedVendorErrorCodeStatusFromJSON,
    UnresolvedVendorErrorCodeStatusFromJSONTyped,
    UnresolvedVendorErrorCodeStatusToJSON,
    UnresolvedVendorErrorCodeStatusToJSONTyped,
} from './UnresolvedVendorErrorCodeStatus';

/**
 * 
 * @export
 * @interface VendorErrorCodeLinkedUnresolvedSummaryDto
 */
export interface VendorErrorCodeLinkedUnresolvedSummaryDto {
    /**
     * Linked UnresolvedVendorErrorCode id
     * @type {string}
     * @memberof VendorErrorCodeLinkedUnresolvedSummaryDto
     */
    id: string;
    /**
     * Current optimistic-concurrency version of the linked unresolved record
     * @type {number}
     * @memberof VendorErrorCodeLinkedUnresolvedSummaryDto
     */
    version: number;
    /**
     * Current status of the linked unresolved record
     * @type {UnresolvedVendorErrorCodeStatus}
     * @memberof VendorErrorCodeLinkedUnresolvedSummaryDto
     */
    status: UnresolvedVendorErrorCodeStatus;
}



/**
 * Check if a given object implements the VendorErrorCodeLinkedUnresolvedSummaryDto interface.
 */
export function instanceOfVendorErrorCodeLinkedUnresolvedSummaryDto(value: object): value is VendorErrorCodeLinkedUnresolvedSummaryDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function VendorErrorCodeLinkedUnresolvedSummaryDtoFromJSON(json: any): VendorErrorCodeLinkedUnresolvedSummaryDto {
    return VendorErrorCodeLinkedUnresolvedSummaryDtoFromJSONTyped(json, false);
}

export function VendorErrorCodeLinkedUnresolvedSummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): VendorErrorCodeLinkedUnresolvedSummaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'version': json['version'],
        'status': UnresolvedVendorErrorCodeStatusFromJSON(json['status']),
    };
}

export function VendorErrorCodeLinkedUnresolvedSummaryDtoToJSON(json: any): VendorErrorCodeLinkedUnresolvedSummaryDto {
    return VendorErrorCodeLinkedUnresolvedSummaryDtoToJSONTyped(json, false);
}

export function VendorErrorCodeLinkedUnresolvedSummaryDtoToJSONTyped(value?: VendorErrorCodeLinkedUnresolvedSummaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'version': value['version'],
        'status': UnresolvedVendorErrorCodeStatusToJSON(value['status']),
    };
}

